import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { BnComparacaoABModule } from 'src/app/shared/modules/bn-comparacao.module';
import { SharedModule } from '../../../shared/shared.module';
import { SolicitacaoHonraModule } from '../../honra/solicitacao-honra/solicitacao-honra.module';
import { NotasModule } from '../../notas/notas.module';
import { CancelamentoCadastroComponent } from '../cancelamento/cancelamento-cadastro.component';
import { CancelamentoDetalheComponent } from '../cancelamento/cancelamento-detalhe.component';
import { CancelamentoListagemComponent } from '../cancelamento/cancelamento-listagem.component';
import { LimiteCadastroComponent } from '../limite/limite-cadastro.component';
import { LimiteFundoCadastroComponent } from '../limite/limite-fundo-cadastro.component';
import { ConsultaCadinPesquisarComponent } from '../consulta-cadin/consulta-cadin-pesquisar.component';
import { ConsultaCadinListarComponent } from '../consulta-cadin/consulta-cadin-listar.component';
import { AditivoPopupComponent } from './aditivo-popup.component';
import { AmortizacaoDetalheComponent } from './amortizacao/amortizacao-detalhe/amortizacao-detalhe.component';
import { DetalheModule } from './detalhe/detalhe.module';
import { LiberacaoDetalheComponent } from './liberacao/liberacao-detalhe.component';
import { ContratacaoLotePesquisaComponent } from './lote-pesquisa/contratacao-lote-pesquisa.component';
import { OperacaoListagemComponent } from './operacao-listagem.component';
import { OperacaoLoteComponent } from './operacao-lote.component';
import { OperacaoPesquisaComponent } from './operacao-pesquisa.component';
import { OperacaoRoutingModule } from './operacao-routing.module';
import { TermosContratacaoModalComponent } from './termos-e-condicoes/termos-contratacao-modal.component';
import { TextoTermosContratacaoComponentTag } from './termos-e-condicoes/texto-termos-contratacao-tag.component';
import { LimitePesquisaComponent } from '../limite/limite-pesquisa.component';
import { LimiteListagemComponent } from '../limite/limite-listagem.component';
import { CancelamentoPesquisaComponent } from '../cancelamento/cancelamento-pesquisa.component';
import { LimiteDetalheComponent } from '../limite/limite-detalhe.component';
import { LimiteContratacaoPesquisaComponent } from '../limite-contratacao/limite-contratacao-pesquisa.component';
import { LimiteContratacaoListagemComponent } from '../limite-contratacao/limite-contratacao-listagem.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { LimiteExposicaoPesquisaComponent } from '../limite-exposicao/pesquisa/limite-exposicao-pesquisa.component';
import { LimiteExposicaoListagemComponent } from '../limite-exposicao/listagem/limite-exposicao-listagem.component';
import { NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { OperacaoRepasseBndesCadastroComponent } from '../operacao-repasse-bndes/operacao-repasse-bndes-cadastro/operacao-repasse-bndes-cadastro.component';
import { CalculoEcgComponent } from '../calculo-ecg/calculo-ecg.component';
import { CalculoSaldoDevedorComponent } from '../calculo-saldo-devedor/calculo-saldo-devedor.component';
import {
  ImportacaoLoteIpdComponent
} from "../../../shared/protocolo-ipd/importacao-lote-ipd/importacao-lote-ipd.component";
import {
  ImportacaoPesquisarIpdComponent
} from "../../../shared/protocolo-ipd/importacao-pesquisar-ipd/importacao-pesquisar-ipd.component";
// import { LimiteHistoricoPesquisaComponent } from '../limite/limite-historico/limite-historico-pesquisa/limite-historico-pesquisa.component';
// import { LimiteHistoricoListagemComponent } from '../limite/limite-historico/limite-historico-listagem/limite-historico-listagem.component';

@NgModule({
  imports: [
    SharedModule,
    OperacaoRoutingModule,
    NotasModule,
    DetalheModule,
    BnComparacaoABModule,
    SolicitacaoHonraModule,
    NgbNav,
    NgSelectModule
  ],
  declarations: [
    AditivoPopupComponent,
    OperacaoListagemComponent,
    OperacaoPesquisaComponent,
    OperacaoLoteComponent,
    ImportacaoLoteIpdComponent,
    TextoTermosContratacaoComponentTag,
    TermosContratacaoModalComponent,
    CancelamentoCadastroComponent,
    CancelamentoListagemComponent,
    CancelamentoPesquisaComponent,
    CancelamentoDetalheComponent,
    LimiteCadastroComponent,
    LimiteFundoCadastroComponent,
    LiberacaoDetalheComponent,
    ContratacaoLotePesquisaComponent,
    ImportacaoPesquisarIpdComponent,
    ConsultaCadinPesquisarComponent,
    ConsultaCadinListarComponent,
    AmortizacaoDetalheComponent,
    LimitePesquisaComponent,
    LimiteListagemComponent,
    LimiteDetalheComponent,
    LimiteContratacaoPesquisaComponent,
    LimiteContratacaoListagemComponent,
    LimiteExposicaoPesquisaComponent,
    LimiteExposicaoListagemComponent,
    OperacaoRepasseBndesCadastroComponent,
    CalculoEcgComponent,
    CalculoSaldoDevedorComponent,
  ],
  providers: [
    DatePipe,
  ]
})
export class OperacaoModule { }
